export default ({ request }) => ({
  /**
   * 获取个人信息
   * @param { header } token
   */
  information() {
    return request({
      url: '/psl/user/info/get',
      method: 'post',
    });
  },
});



// WEBPACK FOOTER //
// ./src/api/modules/user.js